// extracted by mini-css-extract-plugin
export default {"SearchResults":"ResultDisplayer_SearchResults__dvmPw","Protocol":"ResultDisplayer_Protocol__BMRwM","Buttons":"ResultDisplayer_Buttons__CbB0s"};